module.exports = __webpack_public_path__ + "static/Bitcoin-Halvening-Axe-and-Coinstack-72e748f856ce49a26d46f9d23251237d.png";